module.exports = __webpack_public_path__ + "static/img/0.6ad6138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/0.jpg
// module id = 5cRF
// module chunks = 1